module.exports = __webpack_public_path__ + "img/concentration.88946659.png";